(function(
  demac
) {
  'use strict';

  // String helpers

  String.prototype.removeSpaces = function() {
    return this && this.replace(/ /g, '');
  };

  String.prototype.replaceDots = function() {
    return this && this.replace(/[.]/g, '-');
  };

  String.prototype.handleize = function() {
    return this && this.replace(/[^A-Z0-9]/ig, "-").replace(/-+/g, "-").toLowerCase();
  };

  demac.OptionsThumbnail = function(
    $,
    itemsObj,
    itemHandles,
    assetUrlParts,
    itemSel,
    appendSel,
    linkToProdSel
  ) {
    this.init($, itemsObj, itemHandles, assetUrlParts, itemSel, appendSel, linkToProdSel);
  };

  demac.OptionsThumbnail.prototype.init = function($, itemsObj, itemHandles, assetUrlParts, itemSel, appendSel, linkToProdSel) {
    this.$ = $;
    this.itemsObj = itemsObj;
    this.itemHandles = itemHandles;
    this.assetUrlParts = assetUrlParts;
    this.itemSel = itemSel;
    this.appendSel = appendSel;
    this.linkToProdSel = linkToProdSel;

    this.customizeThumbnails();
  };

  // loop through each line item image in cart
  // get appropriate item properties data from passed obj
  demac.OptionsThumbnail.prototype.customizeThumbnails = function() {
    var _this = this;
  
    this.$(this.itemSel).each(function(i) {
      var $imgWrapper = $(this);
      var productHandle = _this.itemHandles[i];
      var $img      = $imgWrapper.find('img');
      var $appendTo = _this.appendSel ? $imgWrapper.find(_this.appendSel): $imgWrapper;

      // return true == continue;
      // return false == break;
      if (!_this.itemsObj[i]) {
        return true;
      }

      // exclude prescription
      if(! productHandle.includes('prescription') && ! productHandle.includes('rx') && ! productHandle.includes('bundle') ) {
        $appendTo.empty();       // empty img wrapper before dumping images in
      }
      $.each(_this.itemsObj[i], function(key, val) {
        if( (key != "Frames Name") && (key != "Lens Bundle") && (key != "Product 1:") ){
          _this.injectImages($appendTo, productHandle, key, val);
        }
      });
      
      if (_this.linkToProdSel) {
        _this.appendParamsToUrl($(this), productHandle, _this.itemsObj[i]);
      }
    });
  };

  // if there are properties,
  // loop through and load each corresponding image from files
  demac.OptionsThumbnail.prototype.injectImages = function($appendTo, productHandle, key, val) {

    if( productHandle.includes('prescription') || productHandle.includes('rx') || productHandle.includes('bundle') ) {
      return;
    }
    
    var imgVal;

    // If image value contains polarize string
    // Append "polarized" to the end of it to match img URL

    if (val.indexOf("POL.") !== -1) {
      imgVal = val.removeSpaces().replaceDots().toLowerCase().concat("polarized");
    } else {
      imgVal = val.removeSpaces().replaceDots().toLowerCase();
    }

    var imgUrl = this.assetUrlParts[0] +
      productHandle + '-' +
      key.replace(' ', '').toLowerCase() + '-' +
      imgVal + '.png' + this.assetUrlParts[1];

    $appendTo
      .append(
        '<img name="' + key + '" ' +
        'style="position:absolute" ' + 
        'src="'+ imgUrl +'" ' +
        'class="layering-image image-' + key.handleize() + '" />'
      )
      .addClass('options-thumbnail');
  };

  // link back to the configured product from the cart
  demac.OptionsThumbnail.prototype.appendParamsToUrl = function($wrapper, productHandle, params) {
    var $link = $wrapper.find(this.linkToProdSel);
    var href = '/products/' + productHandle + '?';

    params = $.param(params);
    href += params;

    $link[0].setAttribute('href', href);
  };
})(
  window.demac = window.demac || {}
);
